/**
 * 功能:
 */

<template lang="pug">
div
  report-nav(:mainId="mainId" justify="space-between" :title="title" :kind="kind")
  el-row(type="flex")
    div.scoll
      el-upload(:action='GLOBAL.uploadHost+"slide/upload"'
        name="image"
        ref='upload'
        :show-file-list="false"
        multiple
        :before-upload="beforeUpload"
        :headers="headers"
        accept="image/jpeg,image/png"
        :on-success="handleUploads")
        el-button(type='primary' @click="handleSelect") 一键导入
      template(v-for="outline in reportTree")
        Thumbnail(:key="outline.wbs" :data="outline"  ref="children")
    Elements.scoll(ref="elements" :data="data" :brief="brief" @changeImage="changeImage")
</template>

<script>
import ReportNav from './components/reportNav'
import apis from '@/apis/slide'
import Brief from '@/apis/brief'
import Thumbnail from './components/slides/thumbnail'
import Elements from './components/slides/elements'
import apiImg from '@/apis/commuCore'
import passport from '@/javascripts/passport'
export default {
  components: { ReportNav, Thumbnail, Elements },
  created () {
    this.mainId = this.$route.query.id
    this.title = localStorage.title
    this.kind = localStorage.kind
    this.loading = true
    apis.getSlide({ id: this.mainId }).then(res => {
      this.loading = false
      this.title = res.data.name
      this.reportTree.push(this.reWbsAndGraphic(res.data))
      // 进入时获取第一张slide及其元素
      if (res.data.children.length > 0 && res.data.children[0].slide.length > 0) {
        const slide = res.data.children[0].slide[0]
        let url = ''
        apiImg.downloadFile(this.GLOBAL.uploadHost + 'illustration/downloadUrl?url=' + slide.hiImageUrl).then(res => {
          url = window.URL.createObjectURL(res)
          const data = { id: slide._id, image: url }
          this.$refs.elements.getElements(data)
        })
      }
    })
    Brief.getBrief({ id: this.mainId }).then(res => {
      this.brief = res.data
    })

    this.$bus.emit('getBriefIndustry', this.brief)
    // 增加删除时切换slide视图
    this.$bus.on('getSlide', (data) => {
      if (data) {
        this.$refs.elements.getElements(data)
      } else {
        this.$refs.elements.getElements()
      }
    })
  },

  data () {
    return {
      headers: passport.headers(),
      kind: 0,
      title: '',
      mainId: 0,
      reportTree: [],
      chartIndex: [], // 图表目录
      data: { },
      brief: { },
      uploadflie: [],
      loadingList: [],
      loading: false
    }
  },
  methods: {
    /* 生成wbs和图解  获取和更改 */
    reWbsAndGraphic (outlines, wbs = '', attachment = {}) {
      if (outlines && outlines.children.length > 0) {
        outlines.children.map((outline, index) => {
          outline.wbs = wbs + (index + 1) + '.'
          outline.children && this.reWbsAndGraphic(outline, outline.wbs, attachment)
        })
      }
      return outlines
    },
    show (ref) {
      this.$refs[ref].show()
    },
    changeImage (loImageUrl, hiImageUrl) {
      this.$refs.children[0].reloadImage()
      apis.getSlide({ id: this.mainId }).then(res => {
        this.reportTree[0] = res.data
      })
    },
    handleSelect (e) {
      // console.log('handleselect', e)
    },
    beforeUpload (e) {
      // console.log('beforeUpload', e)
    },

    hasEmpty (array) {
      for (let i = 0; i < array.length; i++) {
        if (array[i] === '' || array[i] == null || typeof array[i] === 'undefined') {
          return true
        }
      }
      return false
    },
    // 递归找到最后一个目录
    findLastOutline (outline) {
      let lastOutline
      if (outline.children && outline.children.length > 0) {
        lastOutline = outline.children[outline.children.length - 1]
        lastOutline = this.findLastOutline(lastOutline)
        return lastOutline
      }
      return outline
    },
    // 递归找出所有的空目录
    findEmptyOutline (report, emptyOutlines) {
      if (report.children && report.children.length > 0) {
        report.children.forEach(item => {
          if (item.slide.length === 0) {
            emptyOutlines.push(item)
          }
          this.findEmptyOutline(item, emptyOutlines)
        })
      }
      return emptyOutlines
    },

    handleUploads (e, file, fileList) {
      // 如果没有目录 提示
      if (this.reportTree.children && this.reportTree.children.length === 0) return this.$message({ message: '没有目录', type: 'warning' })
      const index = fileList.findIndex(item => {
        return item === file
      })
      this.uploadflie[index] = e
      // 文件已经上传完毕
      if ((this.uploadflie.length === fileList.length) && !this.hasEmpty(this.uploadflie)) {
        // .1 ..1 需要递归判断 目前子对象没有选中
        // 找出所有的空目录
        let emptyOutlines = []
        const lastOutline = this.findLastOutline(this.reportTree[0])
        this.findEmptyOutline(this.reportTree[0], emptyOutlines)
        // 把最后的目录放进存放数组(默认多出来的照片放在最后)
        emptyOutlines.push(lastOutline)
        // 避免最后一个空目录和最后一个目录相同。导致有图片丢失
        emptyOutlines = [...new Set(emptyOutlines)]
        const params = []
        // 上传图片数量超过空目录数量，需要统一处理。不然一个个上传会覆盖原数据造成数据丢失。
        if (this.uploadflie.length > emptyOutlines.length) {
          for (let i = emptyOutlines.length - 1; i < this.uploadflie.length; i++) {
            const url = this.uploadflie[i]
            params.push({ ...url, brief: lastOutline.brief, outline: lastOutline._id })
          }
          apis.uploadSlide({ params: params, outline: lastOutline._id })
            .then(res => {
              for (const slide of res.data) {
                apiImg.downloadFile(this.GLOBAL.uploadHost + 'illustration/downloadUrl?url=' + slide.hiImageUrl).then(val => {
                  slide.hiImageUrl = window.URL.createObjectURL(val)
                  lastOutline.slide.push(slide)
                }).catch(err => { console.log('下载图片失败', err) })
              }
            }).catch(err => { console.log('保存图片失败', err) })
          this.uploadflie = this.uploadflie.slice(0, emptyOutlines.length - 1)
        }
        // 从uploadfile中取出图片地址按顺序放入空目录组里
        // 为了按上传图片的顺序放置目录
        for (let i = 0; i < this.uploadflie.length; i++) {
          const urlObj = this.uploadflie[i]
          const outline = emptyOutlines.shift()
          // 当时最后一个或者没有outline的时候,把剩余所有的图片都放进去params
          const params = [{ ...urlObj, brief: outline.brief, outline: outline._id }]
          apis.uploadSlide({ params: params, outline: outline._id })
            .then(res => {
              for (const slide of res.data) {
                apiImg.downloadFile(this.GLOBAL.uploadHost + 'illustration/downloadUrl?url=' + slide.hiImageUrl).then(val => {
                  slide.hiImageUrl = window.URL.createObjectURL(val)
                  outline.slide.push(slide)
                }).catch(err => { console.log('下载图片失败', err) })
              }
            }).catch(err => { console.log('保存图片失败', err) })
        }
        // 清空上传列表
        this.$refs.upload.clearFiles()
      }
    }
  },

  beforeDestroy () {
    this.$bus.$off('getSlide')
  }
}
</script>

<style scoped>
.scoll {
  max-height: calc(100vh - 50px);
  overflow: auto;
}
</style>
